// extracted by mini-css-extract-plugin
module.exports = {"TaskLogGrid":"TaskLogGridGroup_TaskLogGrid__35BsN","gridOverlay":"TaskLogGridGroup_gridOverlay__2QQXl","taskModal":"TaskLogGridGroup_taskModal__V3u0t"};